module.exports = __webpack_public_path__ + "img/me-ascii_inverted2.9de9c760.png";